import { StackProps, VStack } from '@chakra-ui/react';
import React from 'react';

export const CmVStack: React.FC<StackProps> = ({ children, ...rest }) => {
  // @ts-ignore TS2590
  return <VStack {...rest}>{children}</VStack>;
};
